var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDateRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V10.01C9.25 10.4242 9.58579 10.76 10 10.76H10.01C10.4242 10.76 10.76 10.4242 10.76 10.01V10C10.76 9.58579 10.4242 9.25 10.01 9.25H10Z",
    fill: "#4A304A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.25C5.58579 13.25 5.25 13.5858 5.25 14V14.01C5.25 14.4242 5.58579 14.76 6 14.76H6.01C6.42421 14.76 6.76 14.4242 6.76 14.01V14C6.76 13.5858 6.42421 13.25 6.01 13.25H6Z",
    fill: "#4A304A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.25C7.58579 13.25 7.25 13.5858 7.25 14V14.01C7.25 14.4242 7.58579 14.76 8 14.76H8.01C8.42421 14.76 8.76 14.4242 8.76 14.01V14C8.76 13.5858 8.42421 13.25 8.01 13.25H8Z",
    fill: "#4A304A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14C9.25 13.5858 9.58579 13.25 10 13.25H10.01C10.4242 13.25 10.76 13.5858 10.76 14V14.01C10.76 14.4242 10.4242 14.76 10.01 14.76H10C9.58579 14.76 9.25 14.4242 9.25 14.01V14Z",
    fill: "#4A304A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.25C11.5858 11.25 11.25 11.5858 11.25 12V12.01C11.25 12.4242 11.5858 12.76 12 12.76H12.01C12.4242 12.76 12.76 12.4242 12.76 12.01V12C12.76 11.5858 12.4242 11.25 12.01 11.25H12Z",
    fill: "#4A304A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V14.01C11.25 14.4242 11.5858 14.76 12 14.76H12.01C12.4242 14.76 12.76 14.4242 12.76 14.01V14C12.76 13.5858 12.4242 13.25 12.01 13.25H12Z",
    fill: "#4A304A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12C13.25 11.5858 13.5858 11.25 14 11.25H14.01C14.4242 11.25 14.76 11.5858 14.76 12V12.01C14.76 12.4242 14.4242 12.76 14.01 12.76H14C13.5858 12.76 13.25 12.4242 13.25 12.01V12Z",
    fill: "#4A304A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.005C11.25 9.58803 11.588 9.25 12.005 9.25H14.005C14.422 9.25 14.76 9.58803 14.76 10.005C14.76 10.422 14.422 10.76 14.005 10.76H12.005C11.588 10.76 11.25 10.422 11.25 10.005Z",
    fill: "#4A304A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.005 11.25C5.58803 11.25 5.25 11.588 5.25 12.005C5.25 12.422 5.58803 12.76 6.005 12.76H10.005C10.422 12.76 10.76 12.422 10.76 12.005C10.76 11.588 10.422 11.25 10.005 11.25H6.005Z",
    fill: "#4A304A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 2C6.16421 2 6.5 2.33579 6.5 2.75V4H13.5V2.75C13.5 2.33579 13.8358 2 14.25 2C14.6642 2 15 2.33579 15 2.75V4H15.25C16.7688 4 18 5.23122 18 6.75V15.25C18 16.7688 16.7688 18 15.25 18H4.75C3.23122 18 2 16.7688 2 15.25V6.75C2 5.23122 3.23122 4 4.75 4H5V2.75C5 2.33579 5.33579 2 5.75 2ZM4.75 7.5C4.05964 7.5 3.5 8.05964 3.5 8.75V15.25C3.5 15.9404 4.05964 16.5 4.75 16.5H15.25C15.9404 16.5 16.5 15.9404 16.5 15.25V8.75C16.5 8.05964 15.9404 7.5 15.25 7.5H4.75Z",
    fill: "#4A304A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDateRange);
export default __webpack_public_path__ + "static/media/calendar-date-range.356867ceb53c7f54a5d1eab9bf9a025f.svg";
export { ForwardRef as ReactComponent };